import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { ExcelService } from 'app/misc/excel.service';
import { BulkPayService } from 'app/modules/bulk-pay/bulk-pay.service';
import { CategoryRecipientsComponent } from 'app/modules/bulk-pay/category-recipients/category-recipients.component';
import { Country, Recipient } from 'app/modules/bulk-pay/_state/bulk-pay.interfaces';
import { Bank, MerchantWallet } from 'app/modules/products/_state/products.interfaces';
import { AppState, selectCountries, selectCountriesError, selectCountriesLoading, selectTransactionHistory, selectTransactionHistoryError, selectTransactionHistoryLoading, selectWallets, selectWalletsError, selectWalletsLoading } from 'app/reducers';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as dashboardActions from '../../dashboard/_state/dashboard.actions'
import * as bulkPayActions from '../../bulk-pay/_state/bulk-pay.actions'
import { AuthorizerService } from 'app/modules/authorizers/authorizers.service';

@Component({
  selector: 'app-failed-bulk-pay-transactions',
  templateUrl: './failed-bulk-pay-transactions.component.html',
  styleUrls: ['./failed-bulk-pay-transactions.component.css']
})
export class FailedBulkPayTransactionsComponent extends CategoryRecipientsComponent  implements OnInit {

  constructor(
    protected store: Store<AppState>,
    protected actions$: Actions,
    protected router: Router,
    protected toastr: ToastrService,
    protected route: ActivatedRoute,
    public miscService: MiscService,
    protected bulkpayService: BulkPayService,
    protected excelService : ExcelService,
    protected authorizerService: AuthorizerService
  ) { 
    super(store,actions$,router,toastr,route,miscService,bulkpayService,excelService, authorizerService )
  }

  public unsubscribe$ = new Subject<void>();
  isRecipients: boolean;
  selectedRecipients: Recipient[];
  failedRecipients: Recipient[] = [];
  failedBulkPayTransactions$ = this.store.pipe(select(selectTransactionHistory))
  failedBulkPayTransactionsLoading$ = this.store.pipe(select(selectTransactionHistoryLoading))
  failedBulkPayTransactionsError$ = this.store.pipe(select(selectTransactionHistoryError))

  wallets$ = this.store.pipe(select(selectWallets))
  walletsLoading$ = this.store.pipe(select(selectWalletsLoading))
  walletsError$ = this.store.pipe(select(selectWalletsError))


  ngOnInit(): void {
    this.paymentForm = new FormGroup({
      description: new FormControl(''),
      walletToDebit: new FormControl('', Validators.required)
    })
    this.otpForm = new FormGroup({
      otp: new FormControl('', Validators.required)
    })
    this.countries$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: Country[]) => this.countries = res);
    this.wallets$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: MerchantWallet[]) => this.wallets = res)
    this.fetchFailedBulkPayTransactions();
    this.fetchCountries();
    this.fetchMerchantWallets();
    this.onFetchBalanceSuccessful();
    this.onSendOTPSuccessful();
    this.onUpdateTransactionStatusFailed();
    this.onUpdateTransactionStatusSuccessful();
  }
  getCountry = (code) => this.countries.find(country => code === country.callingCode).currencyCode
    // API CALLS
    fetchFailedBulkPayTransactions = () => {
      this.store.dispatch(dashboardActions.fetchTransactionHistory({txnId: 'bulkpay', status: '1'}))
    }

    // getDlCodes = () => {
    //   this.bulkPayInProcess = true;
    //   this.paymentList.map(payee => {
    //     let requestPayload;
    //     let payeeCountry = this.countries.find(country => payee.country_code === country.callingCode).alpha2Code
    //     if(payeeCountry == 'GB'){
    //        requestPayload = {
    //         config_preset: 'SgKOr2mJp',
    //         transaction_params: {
    //           payeeId: payee.card_num? payee.card_num : payee['bank_sort_code'] + payee['bank_account_no'],
    //           payerId: this.selectedWallet.account_id,
    //           src_amount: this.miscService.formatTo2DecimalPlaces(payee.amount),
    //           des_amount: this.miscService.formatTo2DecimalPlaces(payee.des_amount || payee.amount),
    //         }
    //       }
    //     } else {
    //       requestPayload = {
    //         config_preset: 'SgKOr2mJp',
    //         transaction_params: {
    //           payeeId: payee.card_num? payee.card_num : payee['bank_code'] + payee['bank_account_no'],
    //           payerId: this.selectedWallet.account_id,
    //           src_amount: this.miscService.formatTo2DecimalPlaces(payee.amount),
    //           des_amount: this.miscService.formatTo2DecimalPlaces(payee.des_amount || payee.amount),
    //         }
    //       }
    //     }
    //     this.bulkpayService.generateDLCode(requestPayload).subscribe(
    //       res => {
    //         this.dlCodesRequested++
    //         this.makePayment(payee, res['otp_sid'])
    //       },
    //       err => {
    //         this.dlCodesRequested++
    //         this.toastr.error(`Payment was not completed for ${payee.name}`,'Transaction failed');
    //         this.failedToPay.push({product_id: payee.product_id})
    //         if(this.paymentList.length === this.dlCodesRequested){
    //           this.bulkPayInProcess = false;
    //           if(this.failedToPay.length === this.paymentList.length)
    //             this.updateTransactionStatus( {failed_recipients:this.failedToPay}, '1');
    //           this.toggleOtpModal('close');
    //           this.otpForm.reset();
    //           this.paymentForm.reset();
    //           this.isPaymentPage = null;
    //           this.isNotifying = null;
    //           this.checkingSignatures = null;
    //           this.authorizersNotifed = null;
    //           this.sufficientBalance = null;
    //           this.paymentList = [];
    //           this.fetchFailedBulkPayTransactions();
    //           this.goBack();
    //           this.toastr.info('Check for  failed transactions','Bulk pay not completed');
    //         }
    //       } 
    //       )
    //     })
        
    //   }
    //   generatePaymentReference() {
    //     const currentDate = new Date();
    //     const formattedDate = currentDate.toISOString().replace(/[-:.TZ]/g, '').replace(/\s/g, '');
    //     const reference = `CUD${formattedDate}` + (Math.ceil(Math.random() * 10e13)).toString();
    //     return reference;
    //   }
      
    //   makePayment = (payee: Recipient, dl_code) => {
    //     this.bulkPayInProcess = true;
    //     let requestBody;
    //     let payeeCountry = this.countries.find(country => payee.country_code === country.callingCode).alpha2Code
    //     requestBody = {
    //       otp_sid: this.otpSid,
    //       description: this.paymentForm.get('description').value,
    //       channel_id: "XCelBusiness",
    //       currency: this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).currencyCode,
    //       account_id: this.selectedWallet.account_id || '',
    //       src_scheme: this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004',
    //       des_card_num: payee.card_num || payee['bank_account_no'],
    //       src_country: this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).alpha2Code,
    //       to_provider_code: payee['bank_code'] || '',
    //       type: payee.payment_type == 'Account'? 'bank' : payee.payment_type == 'momo'? 'momo' : 'wallet',
    //       amount: this.miscService.formatTo2DecimalPlaces(payee.amount),
    //       rate: this.countries.find(country => payee.country_code === country.callingCode).alpha2Code == this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).alpha2Code ? '1' : payee.rate,
    //       dest_country: this.countries.find(country => payee.country_code === country.callingCode).alpha2Code ,
    //       account_name: payee.name,
    //       des_currency: this.countries.find(country => payee.country_code === country.callingCode).currencyCode,
    //       sortCode: payee['bank_sort_code']|| '',
    //       OTP: this.otpForm.get('otp').value,
    //       des_amount: this.miscService.formatTo2DecimalPlaces(payee.des_amount || payee.amount),
    //       merchant: false,
    //       dest_scheme: payee.scheme_code,
    //       dl_code
    //   }
    //     // if(payeeCountry == 'GB'){
    //     //   requestBody ={
    //     //     "amount":this.miscService.formatTo2DecimalPlaces(payee.amount),
    //     //     "account_no": payee.wallet? payee.wallet: payee['bank_account_no'],
    //     //     "name": payee.name,
    //     //     "OTP": this.otpForm.get('otp').value,
    //     //     "fees_paid":"0.00",
    //     //     "sortCode": payee['bank_sort_code']|| '',
    //     //     "src_scheme": this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004',
    //     //     "ref_no": this.currentPaymentId,
    //     //     "bank_code": payee['bank_code'] || '',
    //     //     "reference": this.currentPaymentId,
    //     //     "interbank": payee.bank ? this.selectedWallet.sortCode == payee['bank_sort_code']? true : false : true,
    //     //     "merchant": false,
    //     //     "otp_sid": this.otpSid,
    //     //     "auth":"",
    //     //     "src_country":this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).alpha2Code,
    //     //     "international":payee.scheme_code === this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004'? false: true,
    //     //     "src_card_num":this.selectedWallet.account_id,
    //     //     "dest_scheme":payee.scheme_code,
    //     //     "description":this.paymentForm.get('description').value,
    //     //     "org_code":"0000",
    //     //     "id_code":"0000000000",
    //     //     "des_amount": this.miscService.formatTo2DecimalPlaces(payee.amount),
    //     //     "sub_issuer_code":"0000",
    //     //     "currency":this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).currencyCode,
    //     //     "date": new Date().toISOString(),
    //     //     "secureInstallationId":"",
    //     //     "external_reference": this.generatePaymentReference(),
    //     //     // "external_reference": 'CUD' + new Date().toISOString().split('.')[0], //check if it's not meant to be same value as source wallet number
    //     //     "due_fees":{
    //     //        "vat":"0.0",
    //     //        "stamp":"0.0",
    //     //        "transaction":0.00
    //     //     },
    //     //     "src_person":this.miscService.getMerchantDetails().reg_name,
    //     //     "dest_person":payee.name,
    //     //     "dl_code":dl_code,
    //     //     "dest_wallet_no": payee.wallet || '',
    //     //     "account_id": this.selectedWallet.account_id || '', //src or des
    //     //     "destinationAccountId":payee.card_num || '',
    //     //     "merchant_fees":"0",
    //     //     "channel_id":"XCelBusiness",
    //     //     "fees":false,
    //     //     "type": payee.payment_type == 'Account'? 'Bank' : 'Wallet',
    //     //     "accountNumber": payee.wallet || payee['bank_account_no'],
    //     //     "dest_country":this.countries.find(country => payee.country_code === country.callingCode).alpha2Code,
    //     //     "sourceAccountId": this.selectedWallet.account_id || '',
    //     //     "issuer_code":"0000",
    //     //     "des_card_num": payee.card_num,
    //     //     "src_wallet_no":this.selectedWallet.account_number,
    //     //     "pin":"1234",
    //     //     "des_currency":this.countries.find(country => payee.country_code === country.callingCode).currencyCode,
    //     //     "org_br_code":"0000"
    //     //  }
    //     // }
    //     // else{
    //     //   requestBody = {
    //     //     "fees_paid":"0.00",
    //     //     "fees":false,
    //     //     "issuer_code":"0000",
    //     //     "id_code":"0000000000",
    //     //     "src_card_num":this.selectedWallet.account_id,
    //     //     "pin":"1234",
    //     //     "otp_sid": this.otpSid,
    //     //     "src_person":this.miscService.getMerchantDetails().reg_name,
    //     //     "date":new Date().toISOString(),
    //     //     "org_code":"0000",
    //     //     "description":this.paymentForm.get('description').value,
    //     //     "channel_id":"XCelBusiness",
    //     //     "reference": this.currentPaymentId,
    //     //     "interbank": payee.wallet? true: false,
    //     //     "currency":this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).currencyCode,
    //     //     "merchant_fees":"0",
    //     //     "account_id": this.selectedWallet.account_id || '',
    //     //     "bank_code": payee['bank_code'] || '',
    //     //     "sub_issuer_code":"0000",
    //     //     "dest_person":payee.name,
    //     //     "src_scheme":this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004',
    //     //     "due_fees":{
    //     //        "stamp":"0.0",
    //     //        "vat":"0.0",
    //     //        "transaction":0.0
    //     //     },
    //     //     "des_card_num":payee.card_num,
    //     //     "src_country":this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).alpha2Code,
    //     //     "type":payee.payment_type == 'Account'? 'Bank' : 'Wallet',
    //     //     "amount":this.miscService.formatTo2DecimalPlaces(payee.amount),
    //     //     "name":payee.name,
    //     //     "account_no":payee.wallet? payee.wallet: payee['bank_account_no'],
    //     //     "dest_country":this.countries.find(country => payee.country_code === country.callingCode).alpha2Code,
    //     //     "des_currency":this.countries.find(country => payee.country_code === country.callingCode).currencyCode,
    //     //     "external_reference": this.generatePaymentReference(),
    //     //     // "external_reference":'CUD' + new Date().toISOString().split('.')[0], //check if it's not meant to be same value as source wallet number
    //     //     "secureInstallationId":"",
    //     //     "sourceAccountId":this.selectedWallet.account_id || '',
    //     //     "org_br_code":"0000",
    //     //     "sortCode": payee['bank_sort_code']|| '',
    //     //     "ref_no":this.currentPaymentId,
    //     //     "src_wallet_no":this.selectedWallet.account_number,
    //     //     "international":payee.scheme_code === this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004'? false: true,
    //     //     "OTP":this.otpForm.get('otp').value,
    //     //     "des_amount":this.miscService.formatTo2DecimalPlaces(payee.amount),
    //     //     "merchant":false,
    //     //     "destinationAccountId":payee.card_num || '',
    //     //     "accountNumber":payee.wallet || payee['bank_account_no'],
    //     //     "dest_scheme":payee.scheme_code,
    //     //     "dl_code":dl_code,
    //     //     "auth":"",
    //     //     "dest_wallet_no":payee.wallet || ''
    //     //  }
    //     // }
    //     //  requestBody = {
    //     //   "src_scheme": this.miscService.getMerchantDetails().country_code + '004',
    //     //   "auth":"",
    //     //   "type": payee.payment_type,
    //     //   "src_card_num": this.selectedWallet.account_id,
    //     //   "date":new Date().toISOString(),
    //     //   "dest_country": this.countries.find(country => payee.country_code === country.callingCode).alpha2Code,
    //     //   "dest_person": payee.name,
    //     //   "fees_paid":"0.00",
    //     //   "dest_scheme": payee.scheme_code,
    //     //   "sourceAccountId":this.selectedWallet.account_id || '',
    //     //   "description": this.paymentForm.get('description').value,
    //     //   "interbank": payee.wallet? true: false,
    //     //   "sortCode": payee['bank_sort_code']|| '',
    //     //   "currency": this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).currencyCode,
    //     //   "name": payee.name,
    //     //   "ref_no":"",
    //     //   "amount": payee.amount,
    //     //   "src_person": this.miscService.getMerchantDetails().reg_name,
    //     //   "dl_code": dl_code,
    //     //   "account_no": this.selectedWallet.account_number,
    //     //   "due_fees":[],
    //     //   "des_card_num": payee.card_num,
    //     //   "destinationAccountId": payee.card_num,
    //     //   "OTP": this.otpForm.get('otp').value,
    //     //   "src_wallet_no":this.selectedWallet.account_number,
    //     //   "dest_wallet_no": payee.wallet || '',
    //     //   "international": payee.scheme_code === this.miscService.getMerchantDetails().country_code + '004'? false: true,
    //     //   "merchant_fees":"0",
    //     //   "fees":false,
    //     //   "pin":"1234",
    //     //   "merchant":false,
    //     //   "des_amount": payee.amount,
    //     //   "secureInstallationId":"",
    //     //   "channel_id":"XCel Web",
    //     //   "bank_code": payee['bank_code'] || '',
    //     //   "reference": this.currentPaymentId,
    //     //   "accountNumber": this.selectedWallet.account_number,
    //     //   "src_country": this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).alpha2Code,
    //     //   "account_id": this.selectedWallet.account_id,
    //     //   "otp_sid": this.otpSid,
    //     //   "external_ref": 'CUD' + new Date().toISOString().split('.')[0],
    //     //   "sub_issuer_code": "1234",
    //     //   "issuer_code": "1234",
    //     //   "org_code": "1234",
    //     //   "org_br_code": "1234",
    //     //   "id_code": "1234567890"
    //     // }
    //     this.bulkpayService.payRecipient(requestBody, payee.scheme_code).subscribe(
    //       res => {
    //         this.transactionsDone++
    //         this.toastr.success(`Payment to ${payee.name} successful`);
    //         if(this.paymentList.length === this.transactionsDone){
    //           if(this.failedToPay.length === this.paymentList.length)
    //             this.updateTransactionStatus( {failed_recipients:this.failedToPay}, '1');
    //           else if(this.failedToPay.length > 0 && this.failedToPay.length < this.paymentList.length)
    //             this.updateTransactionStatus( {failed_recipients:this.failedToPay}, '2');
    //           else if(this.failedToPay.length == 0)
    //             this.updateTransactionStatus( [], '0');
    //           this.toggleOtpModal('close');
    //           this.bulkPayInProcess = false;
    //           this.otpForm.reset();
    //           this.paymentForm.reset();
    //           this.isPaymentPage = null;
    //           this.isNotifying = null;
    //           this.checkingSignatures = null;
    //           this.authorizersNotifed = null;
    //           this.sufficientBalance = null;
    //           this.paymentList = [];
    //           this.toastr.info('Bulk pay completed');
    //           this.fetchFailedBulkPayTransactions();
    //           this.goBack();
    //         }
    //       },
    //       err => {
    //         this.transactionsDone++
    //         this.failedToPay.push({product_id: payee.product_id})
    //         this.toastr.error(`Payment was not completed for ${payee.name}`,err.error.errors);
    //         if(this.paymentList.length === this.transactionsDone){
    //           if(this.failedToPay.length === this.paymentList.length)
    //             this.updateTransactionStatus( {failed_recipients:this.failedToPay}, '1');
    //           else if(this.failedToPay.length > 0 && this.failedToPay.length < this.paymentList.length)
    //             this.updateTransactionStatus( {failed_recipients:this.failedToPay}, '2');
    //           this.toggleOtpModal('close');
    //           this.bulkPayInProcess = false;
    //           this.otpForm.reset();
    //           this.paymentForm.reset();
    //           this.isPaymentPage = null;
    //           this.isNotifying = null;
    //           this.checkingSignatures = null;
    //           this.authorizersNotifed = null;
    //           this.sufficientBalance = null;
    //           this.paymentList = [];
    //           this.fetchFailedBulkPayTransactions();
    //           this.goBack();
    //           this.toastr.info('Check for pending or failed transactions','Bulk pay completed');
    //         }
    //       }
    //   )
    // }

    onUpdateTransactionStatusSuccessful = () => {
      this.actions$.pipe(
        ofType(bulkPayActions.updateTransactionStatusSuccess),
        takeUntil(this.unsubscribe$)
      ).subscribe(response => {
        this.isUpdatingTransaction = false;
        this.isUpdatingTransactionFailed = false;
        if(this.router.url == '/app/bulk-pay/failed'){
          if(this.status == 'unfinished'){
            this.router.navigate(['/app/bulk-pay/unfinished'])
          } else if(this.status == 'successful' ){
            this.router.navigate(['/app/bulk-pay/successful'])
          } else if (this.status == 'failed'){
            this.router.navigate(['/app/bulk-pay/failed'])
          }
        } else if(this.router.url == '/app/make-payment/transactions/failed'){
         if(this.status == 'successful' ){
            this.router.navigate(['/app/make-payment/transactions/success'])
          } 
        }
      })
    }
    onUpdateTransactionStatusFailed = () => {
      this.actions$.pipe(
        ofType(bulkPayActions.updateTransactionStatusFailed),
        takeUntil(this.unsubscribe$)
        ).subscribe(response => {
          this.isUpdatingTransaction = false;
          this.isUpdatingTransactionFailed = true;
      })
    }

    //Template Interactions
    goBack = () => {
      this.isRecipients = false; 
      this.isPaymentPage = false; 
      this.selectedRecipients = []; 
      this.failedRecipients = [];
    }
    selectForReprocessing = (transaction) => {
      this.selectedRecipients = transaction.recipients
      transaction.failed_recipients.map(recipient => {
        let failedRecipient = this.selectedRecipients.find((selectedRecipient: Recipient) => selectedRecipient.product_id === recipient.product_id);
        this.failedRecipients.push(failedRecipient)
      })
      this.currentPaymentId = transaction.reference_id
      this.paymentList = this.failedRecipients;
      this.totalToPay = this.paymentList.reduce(( sum:any, payee:any) => sum + parseFloat(payee.amount),0)
      this.isPaymentPage = true;
      this.isRecipients = true;
    }

    setUpForPayment = () => {
      this.updateTransactionStatus([], '3');
      this.sendOTP();
      this.toggleOtpModal('open');
      this.toastr.success('A transaction OTP will be sent to your email');
    }
  
  
    // UNSUBCRIBE FROM OBSERVABLES
    ngOnDestroy(): void {
      this.unsubscribe$.next()
      this.unsubscribe$.complete()
    }

}
